import { resolveFieldLabel } from "@repo/shared";
import type { FinancialFieldDefinition } from "@repo/shared/types";

/**
 * The label for a financial field: the model's own label when the field is
 * defined there, else the component's built-in label (`fallbackLabels`, the
 * already-picked `t.fieldLabels` map), else the id.
 */
export function getFieldLabel(
  fieldId: string,
  lang: string,
  fieldDefs?: FinancialFieldDefinition[],
  fallbackLabels?: Readonly<Record<string, string>>,
): string {
  // First, try to find the label from the field definitions (custom model labels)
  if (fieldDefs) {
    const field = fieldDefs.find((f) => f.id === fieldId);
    if (field) {
      return resolveFieldLabel(field, lang);
    }
  }
  // Fallback to component-specific labels
  return fallbackLabels?.[fieldId] || fieldId;
}
